import React, { Component, ReactNode } from 'react';
import { orderDetailsGridPageSize } from '../../appConfig';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { locale } from '../../common/localization/localizationService';
import { faEnvelope, faList } from '@fortawesome/free-solid-svg-icons';
import CommandCell from '../userAdmin/CommandCell';
import routes from '../../common/routes';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ICustomerSearchGridProps {
  data: Array<any>;
  openMessageDialog: (customer: any) => void;
  setSelectedCustomer: (customer: any) => void;
}

export interface ICustomerSearchGridState {
  dataState: Record<string, any>;
}

export class CustomerSearchGrid extends Component<
  ICustomerSearchGridProps,
  ICustomerSearchGridState
> {
  public readonly state: ICustomerSearchGridState = {
    dataState: {
      sort: [
        {
          dir: 'asc',
          field: 'agreementId',
        },
      ],
      take: orderDetailsGridPageSize,
      skip: 0,
    },
  };

  public dataStateChange(event: Record<string, any>): void {
    this.setState({ ...this.state, dataState: event.data });
  }
  private MessageToCustomer(props: any) {
    return (
      <td colSpan={1} className="auto-resize-column">
        <>
          <CommandCell
            {...props}
            edit={this.props.openMessageDialog}
            icon={faEnvelope}
            tooltip={locale.customerSearchGrid._sendMessage}
          />
        </>
      </td>
    );
  }

  private navigateToLogsColumn(props: any) {
    return (
      <td
        colSpan={1}
        className="auto-resize-column"
        onClick={() => this.props.setSelectedCustomer(props.dataItem)}
      >
        <>
          <NavLink to={`${routes.customerLogs.base}`}>
            <td>
              <button className="user-edit-button">
                <FontAwesomeIcon
                  icon={faList}
                  title={locale.customerRegister.grid._showLogs}
                />
              </button>
            </td>
          </NavLink>
        </>
      </td>
    );
  }

  public render(): ReactNode {
    const result = process(this.props.data, this.state.dataState);
    return (
      <>
        <Grid
          {...this.state.dataState}
          className={'customer-search-grid'}
          data={result}
          selectedField="selected"
          pageable
          resizable
          pageSize={orderDetailsGridPageSize}
          onDataStateChange={this.dataStateChange.bind(this)}
        >
          <GridNoRecords>{locale.general._noRecords}</GridNoRecords>

          <GridColumn field="agreementId" title={'ID'} width={60} />
          <GridColumn
            field="commune"
            title={locale.customerSearchGrid._municipality}
            width={74}
          />
          <GridColumn
            field="name"
            title={locale.customerSearchGrid._name}
            className="auto-resize-column"
          />
          <GridColumn
            field="estate"
            title={locale.customerSearchGrid._address}
            className="auto-resize-column"
          />
          <GridColumn
            field="estatePostalCode"
            title={locale.customerSearchGrid._zipCode}
            width={98}
          />
          <GridColumn
            field="unitDescription"
            title={locale.customerSearchGrid._unitDesrciption}
            className="auto-resize-column"
          />
          <GridColumn
            cell={this.MessageToCustomer.bind(this)}
            width={45}
            className={'auto-resize-column'}
            sortable={false}
          />
          <GridColumn
            cell={this.navigateToLogsColumn.bind(this)}
            width={45}
            className={'auto-resize-column'}
            sortable={false}
          />
        </Grid>
      </>
    );
  }
}
